import { useGetReservationLimits } from '@/query/queries/loyalty/useGetReservationLimits';
import { useSaveModerateReservation } from '@/query/queries/loyalty/useSaveModerateReservation';
import { useGetInvestingStatus } from '@/query/queries/investing/useGetInvestingStatus';

export const useEarlyReservation = () => {
  const { data: limits } = useGetReservationLimits();
  const { data: status } = useGetInvestingStatus();
  const { mutateAsync: reserve } = useSaveModerateReservation();

  const loaded = !!limits || !!status;

  const reservedAmount = status?.reserved_amount;

  const isReservationFullAndBecomeAvailable = limits?.available_reserve === 0 && status?.reserved_amount === 0 && limits?.next_available_reserve_opens_at !== null
  const isReservationFullForNextRound = limits?.available_reserve === 0 && status?.reserved_amount === 0 && limits?.next_available_reserve_opens_at === null

  return {
    limits,
    status,
    reserve,
    reservedAmount,
    isReservationFullAndBecomeAvailable,
    isReservationFullForNextRound,
    loaded,
  };
};
